import { render, staticRenderFns } from "./MediaSettings.vue?vue&type=template&id=1805e16a&scoped=true&"
import script from "./MediaSettings.vue?vue&type=script&lang=js&"
export * from "./MediaSettings.vue?vue&type=script&lang=js&"
import style0 from "./MediaSettings.vue?vue&type=style&index=0&id=1805e16a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805e16a",
  null
  
)

export default component.exports